import { createAuthClient } from 'better-auth/client'

// Determine the correct baseURL based on environment
// In development (Vite): empty string uses Vite proxy
// In production: use the actual API URL
const baseURL = import.meta.env.DEV ? '' : import.meta.env.VITE_API_URL

export const authClient = createAuthClient({
  baseURL,
  fetchOptions: {
    credentials: 'include', // required for session cookies
  },
})

export const { signIn, signOut, useSession } = authClient
